import { IIdName } from '@/interfaces/general/IIdName.ts';
import { IFuelType } from '@/interfaces/powerMarkets/IFuelType.ts';
import { IPlant } from '@/interfaces/powerMarkets/plant/IPlant.ts';

export enum aggregateType {
    fuel = 'fuel',
    owner = 'owner',
    group = 'group',
    zone = 'zone',
    historyOfForecast = 'historyOfForecast',
    calculator = 'calculator',
    plain = 'plain',
}

export enum SeriesTypes {
    System = 'System',
    Plant = 'Plant',
    Calculator = 'Calculator',
    History = 'History',
    Dial = 'Dial',
    Ancillary = 'Ancillary',
}

export enum FilterTypes {
    categories = 'categories',
    dataSources = 'dataSources',
    text = 'text',
    country = 'country',
    plant = 'plant',
    multiplePlants = 'multiplePlants',
    hasAccess = 'hasAccess',
}

export interface ISeriesOption {
    aggregateType: aggregateType;
    chartType?: string | null;
    colour?: string | null;
    country: string;
    countryName: string;
    isPlant?: boolean;
    isOwner?: boolean;
    isGroup?: boolean;
    isFuel?: boolean;
    isZone?: boolean;
    calculatorIdArray? : Array<string>;
    optionsId: string | null;
    optionsName: string | null;
    plantsForGroup?: Array<string> | null;
    seriesId: string;
    seriesName: string | null;
}

export interface SeriesFilterOptions {
    text: string;
    country: IIdName;
    categories?: Array<string> | null;
    dataSources?: Array<string> | null;
    plant?: IPlant | IIdName | IFuelType | null;
    plantsArray?: Array<IPlant>;
    hasAccess?: boolean | null;
}

export interface ITypeOption {
    type: SeriesTypes;
    name: string;
    info?: string;
}
